import React from 'react';
import { NavLink } from 'react-router-dom';
import './MenuTop.css';

const MenuTop = () => {
  return(
    <React.Fragment>
      <NavLink 
        className={ ({ isActive }) => isActive ? 'btn ws-btn-blue-2 menu menu--active' : 'btn ws-btn-blue-2 menu' }
         to="/"><i className="bi bi-file-earmark pe-2"></i>Trámites</NavLink>
      <NavLink 
      className={ ({ isActive }) => isActive ? 'btn ms-2 ws-btn-blue-2 menu menu--active' : 'btn ms-2 ws-btn-blue-2 menu' }
        to="/cobranza"><i className="bi bi-currency-dollar pe-2"></i>Cobranza</NavLink>
    </React.Fragment>
  )
}

export default MenuTop;